const STORAGE_KEY = "ABDM_WORKFLOW";
const WorkflowStorage = {
    get() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
        } catch {
            return {};
        }
    }, save(key, value) {
        if (value === undefined || value === null || value === "") return;
        const data = this.get();
        data[key] = value;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        window.dispatchEvent(new Event("workflowChanged"));
    }, getValue(key) {
        return this.get()[key];
    }, remove(key) {
        const data = this.get();
        delete data[key];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        window.dispatchEvent(new Event("workflowChanged"));
    }, clear() {
        localStorage.removeItem(STORAGE_KEY);
        window.dispatchEvent(new Event("workflowChanged"));
    }
};
export default WorkflowStorage;